
import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common';
import user from './modules/user';
import location from './modules/location';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
    },
    mutations: {
    },
    modules: {
        common,
        user,
        location
    },
    strict: process.env.VUE_APP_MY_NODE !== 'PRO'
})
